import { AfterViewInit, ChangeDetectionStrategy, Component, EventEmitter, OnInit, Output, ViewChild } from "@angular/core";
import { Store } from "@ngxs/store";
import { BarcodeFormat } from "@zxing/browser";
import { Result } from "@zxing/library";
import { ZXingScannerComponent } from "@zxing/ngx-scanner";

@Component({
    selector: "pmt-card-qr-scanner-ba",
    templateUrl: "card-qr-scanner-ba.component.html",
    styleUrls: ["card-qr-scanner-ba.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CardQrScannerComponentBA implements AfterViewInit {
    @Output()
    public scanComplete = new EventEmitter<string>();

    @ViewChild("scanner", { static: false })
    public scanner: ZXingScannerComponent;

    public allowedFormats = [BarcodeFormat.QR_CODE];

    public isTorchOn = false;

    public isTorchCompatible = false;
    public cameras: MediaDeviceInfo[];
    public activeCamera: MediaDeviceInfo;

    public get canChangeCamera() {
        return this.cameras?.length > 1;
    }

    constructor(private store: Store) {
    }

    public ngAfterViewInit(): void {
        this.activeCamera = this.scanner.device;
    }

    public setCardGuid(cardGuid: string) {
        this.scanComplete.emit(cardGuid);
    }

    public changeCamera(deviceId: string) {
        if (this.cameras.length < 2) {
            return;
        }

        this.isTorchOn = false;

        const desiredDevice = this.cameras.find((_) => _.deviceId === deviceId);
        this.activeCamera = desiredDevice;
        this.scanner.device = desiredDevice;
    }

    public toggleTorch() {
        this.isTorchOn = !this.isTorchOn;
    }

    public torchCompatibleHandler(event: boolean) {
        // console.log("torchCompatible", event);
        this.isTorchCompatible = event;

        if (this.isTorchOn && !this.isTorchCompatible) {
            this.isTorchOn = false;
        }
    }

    public camerasFoundHandler(event: MediaDeviceInfo[]) {
        // console.log("camerasFound", event);
        this.cameras = event;
        this.activeCamera = this.scanner.device;
    }

    public camerasNotFoundHandler(event: any) {
        // console.log("camerasNotFound", event);
    }

    public scanSuccessHandler(event: string) {

        this.setCardGuid(event);
    }

    public scanErrorHandler(event: any) {
        // console.log("scanError", event);
    }

    public scanFailureHandler(event: any) {
        // console.log("scanFailure", event);
    }

    public scanCompleteHandler(event: Result) {
        // console.log("scanComplete", event);
    }
}
